<footer>
  <div class="barrapie">
    <div class="pie">
      <a
        aria-label="CEME, S.L."
        target="_blank"
        href="https://www.infoguadiana.com/"
      >
        <img
          alt="Ceme Logo"
          src="../../assets/img/Simbolo_RGB.png"
          width="75"
        />
      </a>
      <span class="marca">&copy; {{ fecdia }} INFOGUADIANA SL. V-11.7</span>
    </div>
  </div>
</footer>
